import { IBISReport } from "../ibis-report";
import { RoT } from "../rot";
import { RPi } from "../rpi";
import { Sic } from "../sic";

export class PullResultData {
  SIC: Sic;
  ADD_SIC: Sic[];
  ROT: RoT;
  RPI: RPi;
  IBIS: IBISReport;

  constructor(value: any = {}) {
    Object.assign(this, value);

    if(value.SIC)
      this.SIC = new Sic(value.SIC);

    if(value.ADD_SIC)
      this.ADD_SIC = Sic.parseArray(value.ADD_SIC);
    else
      this.ADD_SIC = [];

    if (value.ROT)
      this.ROT = new RoT(value.ROT);

    if(value.RPI)
      this.RPI = new RPi(value.RPI);

    if(value.IBIS)
      this.IBIS = new IBISReport(value.IBIS);
  }

  static parseArray(json: any[]): PullResultData[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new PullResultData(j));
        }
      }
    }

    return arr;
  }
}
